/* FA locale-links: keep the active market/locale URL prefix on internal storefront links.
 * - Adds the current locale prefix to unprefixed storefront links.
 * - Normalises links that carry a DIFFERENT locale prefix to the current locale.
 * Skips language/currency switcher links (forms, hreflang, rel=alternate, localization UI). */
(function(){
  var root = String(window.__faRoot || '/').replace(/\/+$/,''); /* '' on default locale */
  var CONTENT = /^\/(pages|products|collections|blogs|account|cart|search|policies)(\/|$)/;
  var ADDRX   = /^\/(pages|products|collections|blogs)(\/|$)/;
  var LOCSEG  = /^\/(?:en|zh|ms|id)(?:-[a-z]{2,4})?(?=\/|$)/i;
  function skip(a){
    if(a.closest && (a.closest('form') ||
        a.closest('[class*="localiz"],[data-localization],.currencyLang,.disclosure,[class*="lang-"]'))) return true;
    if(a.getAttribute('hreflang')) return true;
    if(/alternate/i.test(a.getAttribute('rel')||'')) return true;
    return false;
  }
  function fix(a){
    var href = a.getAttribute('href'); if(!href) return;
    var path = href;
    if(/^https?:\/\//i.test(href)){
      var u; try{ u = new URL(href); }catch(e){ return; }
      if(u.hostname !== location.hostname) return; /* external */
      path = u.pathname + u.search + u.hash;
    } else if(href.charAt(0) !== '/'){ return; } /* anchors, mailto, tel, page-relative */
    if(path === root || (root && path.indexOf(root + '/') === 0)) return; /* already current locale */
    if(skip(a)) return;
    var m = path.match(LOCSEG);
    if(m){ /* link carries a different locale prefix -> normalise to current locale */
      var rest = path.slice(m[0].length);
      if(rest.charAt(0) !== '/') rest = '/' + rest;
      if(rest !== '/' && !CONTENT.test(rest)) return; /* only storefront links */
      a.setAttribute('href', (root + (rest === '/' ? '' : rest)) || '/');
      return;
    }
    /* unprefixed -> add current locale prefix to storefront content links */
    if(!root) return;
    if(!ADDRX.test(path)) return;
    a.setAttribute('href', root + path);
  }
  function scan(r){ if(!r || !r.querySelectorAll) return; var l = r.querySelectorAll('a[href]'); for(var i=0;i<l.length;i++) fix(l[i]); }
  function run(){
    scan(document);
    if(window.MutationObserver && document.body){
      new MutationObserver(function(m){
        for(var i=0;i<m.length;i++){ var n=m[i].addedNodes; for(var j=0;j<n.length;j++){ var e=n[j]; if(e.nodeType!==1) continue; if(e.tagName==='A') fix(e); scan(e); } }
      }).observe(document.body,{childList:true,subtree:true});
    }
  }
  if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
